/**
 * @flow
 */

import React, { Component } from 'react'

import {
  MapDescriptionSectionContainer,
  MapDescriptionSectionHeading,
  MapDescriptionSectionContent,
  AddressContainer,
  AddressHeading,
  Description,
  ContactNoDescription,
  AddressWrapper
} from './styledComponents'

class MapDescriptionSection extends Component {
  getTelLink = tel => `tel:${tel}`
  render() {
    const {
      amonaraSectionHeading,
      amonaraSectionDescription,
      addressHeading,
      address,
      landmarkHeading,
      landmark,
      contactNoHeading,
      contactNumber,
      isSuper30Page
    } = this.props

    const splitNumber = contactNumber.split(',')
    return (
      <MapDescriptionSectionContainer isSuper30Page={isSuper30Page}>
        <MapDescriptionSectionHeading
          dangerouslySetInnerHTML={{
            __html: amonaraSectionHeading
          }}
          as="h2"
        />
        <MapDescriptionSectionContent
          dangerouslySetInnerHTML={{
            __html: amonaraSectionDescription
          }}
          as="p"
        />
        <AddressWrapper>
          <AddressContainer>
            <AddressHeading as="div">{addressHeading}</AddressHeading>
            <Description as="div">{address}</Description>
          </AddressContainer>
          <AddressContainer>
            <AddressHeading as="div">{landmarkHeading}</AddressHeading>
            <Description as="div">{landmark}</Description>
          </AddressContainer>
          <AddressContainer>
            <AddressHeading as="div">{contactNoHeading}</AddressHeading>
            {contactNumber && (
              <div>
                {contactNumber.indexOf(',') > -1 ? (
                  <span>
                    <ContactNoDescription
                      as="a"
                      href={this.getTelLink(splitNumber[0])}
                    >
                      {splitNumber[0]}
                    </ContactNoDescription>
                    <ContactNoDescription>
                      <ContactNoDescription
                        as="a"
                        href={this.getTelLink(splitNumber[1])}
                      >
                        ,{splitNumber[1]}
                      </ContactNoDescription>
                    </ContactNoDescription>
                  </span>
                ) : (
                  <ContactNoDescription>
                    <ContactNoDescription
                      as="a"
                      href={this.getTelLink(contactNumber)}
                    >
                      {contactNumber}
                    </ContactNoDescription>
                  </ContactNoDescription>
                )}
              </div>
            )}
          </AddressContainer>
        </AddressWrapper>
      </MapDescriptionSectionContainer>
    )
  }
}

export default MapDescriptionSection



// WEBPACK FOOTER //
// ./src/components/IbcArcade/MapSection/MapDescriptionSection/index.js